<template>

<div>
    <select v-model="type" @change="change" class="form-control mb-1">
        <option v-for="option in allowedOptions" :value="option">{{ option }}</option>
    </select>

    <color-picker v-if="type=='solid'" v-model="color" @change="inputColor" />


    <div v-if="type=='gradient'" class="form-row">
        <div class="col">
            <color-picker v-model="gradientFrom" @change="inputGradientFrom" />
        </div>
        <div class="col">
            <color-picker v-model="gradientTo" @change="inputGradientTo" />
        </div>
        <div class="col">
            <select v-model="angle" class="form-control" @change="change">
                <option value="90">⇒</option>
                <option value="180">⇓</option>
                <option value="45">⇗</option>
                <option value="135">⇘</option>
            </select>
        </div>

    </div>
    <div v-if="type=='image'">

        <div class="form-row">
            <div class="col">
                <input type="file" class="form-control" @change="onFileChange">
            </div>
            <div class="col" v-if="handler">
                <img :src="handler">
                <span class="close" @click="removeImage">&times;</span>
            </div>
        </div>
        <div class="form-row">
            <div class="col">
                <label>{{_lang('Color','input')}}</label>
                <color-picker v-model="color" @change="inputColor" />
            </div>
            <div class="col">
                <label>{{_lang('Position','input')}}</label>
                <select v-model="position" class="form-control" @change="change">
                    <option value="center">center</option>
                    <option value="left center">left center</option>
                    <option value="right center">right center</option>
                    <option value="top center">top center</option>
                    <option value="bottom center">bottom center</option>
                    <option value="top left">top left</option>
                    <option value="top right">top right</option>
                    <option value="bottom left">bottom left</option>
                    <option value="bottom right">bottom right</option>
                </select>
            </div>
        </div>
    </div>
</div>

</template>
<style scoped>
.close {
    position: absolute;;
    top: 0;
    z-index: 2;
    right: 10px;
    background: #fff;
    border-radius: 50px;
    width: 1.5rem;
    text-align: center;
    cursor: pointer;

}

</style>

<script>
import axios from 'axios';
import ColorPicker from './ColorPicker';

export default {
  props: ['config', 'name', 'value'],
  components:{
      'color-picker':ColorPicker,
  },

  data(){
      return {
          options:[ 'solid', 'gradient', 'image'],
          type:'solid',
          handler:'',
          color:'#f1f1f1',
          repeat:'no-repeat',
          position:'center',

          gradientFrom:'#d1ffe1',
          gradientTo:'#bfe7ff',
          angle:'90',
      }
  },
  computed:{
    allowedOptions(){
      if(!this.allowed) return this.options;
      return this.options.filter(item=>{
        return this.allowed.includes(item);
      })
    },
    allowed(){
      if(!this.config.vars || !this.config.vars.allowed) return false;
      return this.config.vars.allowed;
    }
  },
  created(){
      var match = this.value.match(/url\(['"]?([^)]+)['"]?\)/);
      if(match){
          this.handler = match[1];
          this.type = 'image';

          match = this.value.match(/(#[0-9a-f]+|rgba\([^)]+?\))/i)
          if(match) this.color = match[1];

          match = this.value.match(/\b((?:top|right|bottom|left|center)(?: (?:top|right|bottom|left|center))?)\b/i)
          if(match) this.position = match[1];

      }
      var match = this.value.match(/^(#[0-9a-f]+|rgba\([^)]+?\)|transparent)$/);
        if(match){
            this.type = 'solid';
            this.color = this.value;
        }

      var match = this.value.match(/linear-gradient\((\d+)deg, ?([^ ]+) 0%,  ?([^ ]+) 100%\)/);
        if(match){
            //this.handler = match[1];
            this.type = 'gradient';
            this.angle = match[1];
            this.gradientFrom = match[2];
            this.gradientTo = match[3];
        }


  },
  methods:{
    removeImage(){
        this.handler = '';
        this.$emit('change','');
    },
    inputColor(newcolor){
        this.color = newcolor;
        this.change();
    },
    inputGradientFrom(newcolor){
        this.gradientFrom = newcolor;
        this.change();
    },
    inputGradientTo(newcolor){
        this.gradientTo = newcolor;
        this.change();
    },
    change(newval){
        if(this.type=='solid'){
            newval=this.color;
            this.$emit('change',newval);
        }
        if(this.type=='gradient'){
            newval=`linear-gradient(${this.angle}deg, ${this.gradientFrom} 0%, ${this.gradientTo} 100%)`
            this.$emit('change',newval);
        }
        if(this.type=='image'){
            newval = `url(${this.handler}) no-repeat ${this.position}`;
            if(this.color) newval += ' '+this.color;
            this.$emit('change',newval);
        }

    },

    onFileChange(event,field){
        var files = event.target.files || event.dataTransfer.files;

        var file = files[0];
        if(!file) return;
        event.target.value='';

        var reader = new FileReader();
        reader.onload = (e) => {
            var base64 =  e.target.result;
            var data = {
                name:file.name,
                content:base64
            }

            axios.post('/api/upload',data).then((response)=> {
                this.handler = response.data;
                this.change();
            }).catch((error) =>  {
                console.error(error);
                if(error.response) alert(error.response.data);
            })

        }
        reader.readAsDataURL(file);
    }

  }

}
</script>
